import { CSS as ImageButtonCSS } from '../../components/button/image.button.style';
import { addStyles, DefaultTheme } from '../../components/theme';
import { ColorPalette2022Branding } from '../../components/theme.palette';

export const CSS = {
	container: 'c-CollectionEdit',
	isMissing: 'c-CollectionEdit--is-missing',
	isLoading: 'c-CollectionEdit--is-loading',
	isEmpty: 'c-CollectionEdit--empty',

	leftIcon: 'c-CollectionEdit__Icon',
	title: {
		container: 'c-CollectionEditTitle',
		tools: 'c-CollectionEditTitle__Tools',
		save: 'c-CollectionEditTitle__Save',
		discard: 'c-CollectionEditTitle__Discard',
		title: 'c-CollectionEditTitle__Text',
		form: 'c-CollectionEditTitle__Form',
		isInvalid: 'c-CollectionEditTitle--invalid',
	},
	zoom: 'c-CollectionEditTitle__Zoom',
	field: {
		container: 'c-CollectionField',
		summary: 'c-CollectionField__Summary',
		detail: 'c-CollectionField__Detail',
		title: 'c-CollectionField__Title',
		value: 'c-CollectionField__Value',
		isImageUpload: 'c-CollectionFiled__ImageUpload',
		colorIndicator: 'c-CollectionField__ColorIndicator',
		redDot: 'c-CollectionField__RedDot',
	},
	form: {
		container: 'c-SubForm',
		header: 'c-SubForm__Header',
		title: 'c-SubForm__Title',
		tools: 'c-SubForm__Tools',
		footer: 'c-SubForm__Footer',
		footerButton: 'c-SubForm__FooterButton',
		titleName: 'c-SubForm__TitleName',
		titleCount: 'c-SubForm__TitleCount',
		actions: 'c-SubForm__Actions',
		isRoot: 'c-SubForm--is-root',
	},
	instance: {
		container: 'c-SubFormInstance',
		header: 'c-SubFormInstance__Header',
		icon: 'c-SubFormInstance_Icon',
		title: 'c-SubFormInstance_Title',
		tools: 'c-SubFormInstance___Tools',
		text: 'c-SubFormInstance_Text',
		isOpen: 'c-SubFormInstance--is-open',
	},
};
export const ZOOM_WIDTH = '460px';
export const ZOOM_HEIGHT = '200px';

addStyles({
	[CSS.container]: {
		'background-color': DefaultTheme.background.offWhite,
		'white-space': 'nowrap',
		'font-family': DefaultTheme.font.familyCondensed,
		display: 'flex',
		'flex-direction': 'column',
		width: '100%',
		height: '100%',
		'max-height': '100%',
		'border-left': '1px solid ' + DefaultTheme.font.color.divider,
		'border-right': '1px solid ' + DefaultTheme.font.color.divider,
	},
	[CSS.isMissing]: {
		'align-items': 'center',
		'justify-content': 'center',
	},
	[CSS.isLoading]: {
		'align-items': 'center',
		'justify-content': 'center',
	},
	[CSS.title.container]: {
		display: 'flex',
		'background-color': DefaultTheme.background.lightGrey,
		'align-items': 'center',
		'justify-content': 'space-between',
		padding: '4px',
		height: DefaultTheme.space(6),
		'min-height': DefaultTheme.space(6),
		'line-height': DefaultTheme.space(6),
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[CSS.title.save]: {
		color: DefaultTheme.color.accent,
	},
	[CSS.title.title]: {
		'text-transform': 'inherit',
		'font-weight': 'inherit',
		'font-family': 'inherit',
	},
	[CSS.zoom]: {
		height: ZOOM_HEIGHT,
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'flex-shrink': 0,
		'background-color': DefaultTheme.background.lightGrey,
		'box-shadow': DefaultTheme.shadow.box.bottom,
	},
	[CSS.field.title]: {
		flex: '1 0 30%',
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[CSS.field.value]: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		color: DefaultTheme.font.color.supporting,
		overflow: 'hidden',
		width: '100%',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[CSS.field.isImageUpload]: {
		display: 'flex',
		'justify-content': 'space-between',
		'align-items': 'center',
		height: '20px',
		width: '20px',
		'min-width': '20px',
		'margin-left': DefaultTheme.space(1),
		'margin-right': DefaultTheme.space(1),
	},
	[CSS.field.colorIndicator]: {
		height: DefaultTheme.space(3),
		width: DefaultTheme.space(3),
		borderRadius: '50%',
		marginRight: '38px',
	},
	[CSS.field.container]: {
		padding: '4px ' + DefaultTheme.space(2),
	},
	[CSS.field.summary]: {
		display: 'flex',
		'justify-content': 'space-between',
		'align-items': 'center',
		[`& .${ImageButtonCSS.container}`]: {
			height: '20px',
			width: '20px',
			'min-width': '20px',
			'margin-left': DefaultTheme.space(1),
		},
	},
	[CSS.field.detail]: {
		'margin-top': DefaultTheme.space(1),
		'border-left': '2px solid ' + DefaultTheme.font.color.divider,
		display: 'flex',
		'flex-direction': 'column',
		'align-items': 'center',
	},
	[CSS.form.container]: {
		padding: '8px 0px 4px 0',
	},
	[CSS.form.isRoot]: {
		'overflow-x': 'hidden',
		'overflow-y': 'auto',
	},
	[CSS.form.header]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
		padding: `0 ${DefaultTheme.space(2)}`,
		[`& .${CSS.form.tools}`]: {
			display: 'none',
		},
		[`&:hover .${CSS.form.tools}`]: {
			display: 'flex',
		},
	},
	[CSS.form.title]: {
		'font-weight': 'bold',
		display: 'flex',
	},
	[CSS.form.tools]: {
		[`& .${ImageButtonCSS.container}`]: {
			height: '20px',
			width: '20px',
			'min-width': '20px',
			'padding-left': DefaultTheme.space(1),
		},
	},
	[CSS.form.footer]: {
		'margin-left': DefaultTheme.space(2),
		display: 'flex',
		'justify-content': 'space-between',
	},
	[CSS.form.footerButton]: {
		display: 'flex',
		'align-items': 'center',
		'margin-right': DefaultTheme.space(2),
		'font-weight': 'normal',
		'text-transform': 'none',
		'font-family': DefaultTheme.font.familyCondensed,
		color: DefaultTheme.font.color.supporting,
		'&:hover': {
			color: DefaultTheme.font.color.primary,
		},
		'& i': {
			'padding-right': DefaultTheme.space(1),
		},
	},
	[CSS.form.titleCount]: {
		'margin-left': DefaultTheme.space(1),
		color: DefaultTheme.color.accent,
	},
	[CSS.instance.container]: {
		'margin-left': DefaultTheme.space(2),
	},
	[CSS.instance.header]: {
		display: 'flex',
		'background-color': DefaultTheme.background.lightGrey,
		'align-items': 'center',
		'justify-content': 'space-between',
		padding: `${DefaultTheme.space(2)} 0 ${DefaultTheme.space(2)} ${DefaultTheme.space(2)}`,
		height: DefaultTheme.space(6),
		'line-height': DefaultTheme.space(6),
		cursor: 'pointer',
		'border-left': '2px solid ' + DefaultTheme.background.lightGrey,

		'&:hover': {
			'background-color': DefaultTheme.background.grey,
			'border-left': '2px solid ' + DefaultTheme.color.accent,
		},
		[`& .${CSS.instance.tools}`]: {
			display: 'none',
		},
		[`&:hover .${CSS.instance.tools}`]: {
			display: 'flex',
		},
	},
	[CSS.instance.icon]: {
		width: DefaultTheme.space(8),
		position: 'absolute',
		left: '-36px',
	},
	[CSS.instance.isOpen]: {
		'margin-top': '12px',
		'margin-bottom': '8px',
		'box-shadow': DefaultTheme.shadow.box.dp2,
	},
	[CSS.instance.title]: {
		display: 'flex',
		'align-items': 'center',
		position: 'relative',
	},
	[CSS.instance.text]: {
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[CSS.field.redDot]: {
		display: 'inline-block',
		width: '8px',
		height: '8px',
		'border-radius': '50%',
		'background-color': ColorPalette2022Branding.lightRed,
		border: '1px solid #FFFFFF',
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'margin-left': DefaultTheme.space(1),
		'flex-shrink': '0',
	},
	[CSS.isEmpty]: {
		color: DefaultTheme.font.color.disabled,
	},

	[`${CSS.isEmpty} ${CSS.form.header}`]: {
		padding: 0,
	},
});
